import { sbaas } from '@/config';
import { InfoCircleOutlined, RedoOutlined } from '@ant-design/icons';
import {
  Button,
  Checkbox,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Tooltip,
} from 'antd';
import { Header } from 'antd/lib/layout/layout';
import React, { Fragment, useEffect, useState } from 'react';
import { Layer, Stage, Line } from 'react-konva';
import { RouteComponentProps, useHistory } from 'react-router-dom';
// import Banner from '@/assets/banner.jpeg';

type LayoutType = Parameters<typeof Form>[0]['layout'];
const { Option } = Select;

// function downloadURI(uri: string, name: string) {
//   var link = document.createElement('a');
//   link.download = name;
//   link.href = uri;
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// }

const DataForm = ({ match }: RouteComponentProps) => {
  //consts --------------------------------
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingKirim, setIsLoadingKirim] = useState(false);
  const [isLoadingSubmit, setLoadingSubmit] = useState(false);
  const [custName, setCustName] = useState<any>(null);
  const [phoneNo, setPhoneNo] = useState<any>(null);
  const [email, setEmail] = useState<any>(null);
  const [phoneBrand, setPhoneBrand] = useState<any>([]);
  const [unit, setUnit] = useState<any>([]);
  const [checkboxVal, setcbVal] = useState(['0']);
  const [oldBrand, setOldBrand] = useState('No Model');
  const [oldIMEI, setOldIMEI] = useState('');
  const [newIMEI, setNewIMEI] = useState('');
  const [isBackup, setIsBackup] = useState(false);
  const [isPrivacy, setIsPrivacy] = useState(false);
  const [isPromotion, setIsPromotion] = useState(false);
  const [formLayout, setFormLayout] = useState<LayoutType>('vertical');
  const [form] = Form.useForm();
  const [newUnit, setNewUnit] = useState<any>('');
  const [isDataBackup, setIsDataBackup] = React.useState(false);
  const [isDemo, setIsDemo] = useState(false);
  const [isVGC, setIsVGC] = useState('');
  const [isWorking, setIsWorking] = useState<any>(null);
  // const [isNewPhone, setIsNewPhone] = React.useState(false);
  const [strOldPhone, setStrOldPhone] = useState<string>('Saat Ini');
  const [strStoreServices, setStrStoreServices] = useState('');
  // const [notifCantSubmit, setNotifCantSubmit] = React.useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleRefresh, setVisibleRefresh] = useState(false);
  const [gender, setGender] = useState('');
  const [customerType, setCustomerType] = useState<any>('');
  const [interestingUnit, setInterestingUnit] = useState<any>(null);
  const [reasons, setReasons] = useState<any>([]);
  const [reasonsNotBuying, setReasonsNotBuying] = useState<any>(null);
  const [storeServices, setStoreServices] = useState<any>([]);
  const [disablingSubmit, setDisablingSubmit] = useState(true);
  const [readyToSubmit, setreadyToSubmit] = useState(false);
  const history = useHistory();
  var token: Headers = new Headers();
  let data = match.params['data'];
  const nameTip = (
    <p style={{ color: 'black' }}>
      Diisi dengan lengkap sesuai KTP,{' '}
      <b>Hindarkan Penggunaan Jabatan di Awal Nama</b>, seperti Bapak, Ibu, Pak
      dan sebagainya, dan <b>Hindarkan Juga adanya Angka di Nama Anda</b>
    </p>
  );

  const onFormLayoutChange = ({ layout }: { layout: LayoutType }) => {
    setFormLayout(layout);
  };

  const onSearch = (value: string) => {
    console.log('search:', value);
  };

  const validateCustName = (inputText: String) => {
    if (inputText === undefined || inputText === null) {
      return true;
    }

    // console.log(inputText.trim());

    if (
      (inputText.trim().length === 1 && inputText.trim()[0] === "'") ||
      (inputText.trim().length >= 1 &&
        inputText.trim()[0] === "'" &&
        inputText.trim()[1] === "'") ||
      inputText.trim().length === 0
    ) {
      return false;
    }

    var custNameFormat = /^([a-zA-Z' ]{1,50})$/;
    if (custNameFormat.test(String(inputText.toLowerCase()))) {
      return true;
    } else {
      return false;
    }
  };

  const validatePhoneNumber = (inputText: String) => {
    if (inputText === undefined || inputText === null) {
      return true;
    }

    var phoneNumberFormat = /^([1-9])([0-9]{7,11})$/;
    if (phoneNumberFormat.test(String(inputText.toLowerCase()))) {
      return true;
    } else {
      return false;
    }
  };

  const validateEmail = (inputText: String) => {
    if (inputText === undefined || inputText === null) {
      return true;
    }
    // eslint-disable-next-line
    var mailFormat = /\w+(?:[.-]\w+)*@\w+(?:[.-]\w+)*(?:\.[a-zA-Z]{2,4})+$/;
    // var mailFormat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/;
    if (mailFormat.test(String(inputText.toLowerCase()))) {
      return true;
    } else {
      return false;
    }
  };

  const validateIMEI = (inputText: string) => {
    if (inputText === undefined || inputText === null || inputText === '') {
      return true;
    }
    // eslint-disable-next-line
    var imeiFormat = /^[a-zA-Z0-9]*$/;
    if (imeiFormat.test(String(inputText.toLowerCase()))) {
      return true;
    } else {
      return false;
    }
  };

  const fetchPage = async () => {
    // try {
    // var response: any;
    await sbaas
      .script('get_cs_page_info')
      .get({
        query: {
          qr_value: data,
        },
      })
      .then(res => {
        if (res.data.status) {
          localStorage.setItem('token', res.data.token);
        }
      });
    // } catch (error) {}
  };

  const storeServicesToString = async () => {
    fetchPage();

    let key: string | any = localStorage.getItem('token');
    // console.log("key: ", key)
    // key = 'asdf'
    token.append('x-sb-token', key);

    let storeServices: any;
    try {
      await sbaas
        .dbGen('dbGeneric', 'cs_transaction_store_services')
        .get({
          headers: token,
        })
        .then(response => {
          // console.log("response kirim: ", response)
          if (response.data.http_code === 401) {
            console.log('expired token');
            fetchPage();
            setIsLoadingKirim(false);
          } else {
            storeServices = response.data.data;
          }
        });
    } catch (result) {
      // console.log("response error: ", result)
      fetchPage();
      setIsLoadingKirim(false);
      return;
      // console.log("response kirim: ", response)
    }

    let totalBit = 0;
    checkboxVal.forEach(e => {
      totalBit = totalBit + parseInt(e);
    });

    let str = '';

    for (let i = 0; i < storeServices.length; i++) {
      if ((totalBit & storeServices[i].service_bit_value) !== 0) {
        str += storeServices[i].service_name;
        str += ', ';
      }
    }

    const strSS = str.slice(0, -2) + '';

    setStrStoreServices(strSS);
  };

  const submitData = async () => {
    let key: string | any = localStorage.getItem('token');
    token.append('x-sb-token', key);

    try {
      sbaas
        .dbGen('dbGeneric', 'cs_qr_list')
        .get({
          headers: token,
          query: `qr_value=${data}`,
        })
        .then(async response => {
          // console.log('cs_qr_list: ', response.data.data);
          if (
            response.data.data[0].cs_transaction_id &&
            response.data.data[0].cs_transaction_id !== null
          ) {
            setVisibleRefresh(true);
            return;
          } else {
            let storeService = 0;

            checkboxVal.forEach(e => {
              storeService = storeService + parseInt(e);
              // console.log(typeof parseInt(e));
            });

            const emptyStock = storeServices.find(
              (element: any) =>
                element.service_name === 'Empty Stock Notification',
            );

            if (reasonsNotBuying === 2) {
              storeService += emptyStock.service_bit_value;
            }

            let reason_not_buying = reasonsNotBuying;
            let interesting_unit = interestingUnit;
            let new_imei = newIMEI;
            let old_brand = oldBrand;
            let is_backup = isBackup;
            let is_working = isWorking;

            if (newUnit) {
              interesting_unit = null;
              reason_not_buying = null;
            } else {
              new_imei = '';
              old_brand = 'No Model';
              if (reasonsNotBuying === 1 || reasonsNotBuying === 4) {
                interesting_unit = null;
              }
            }

            if (!isDataBackup) {
              is_backup = false;
            }

            if (!isDemo) {
              is_working = null;
            }
            // downloadURI(stageRef.current.toDataURL(), 'test_image');
            let fileBlob = dataURItoBlob(
              stageRef.current && stageRef.current.toDataURL(),
            );

            const signatureFileName = Date.now() + '.png';
            const file = new File([fileBlob], signatureFileName, {
              type: 'image/png',
            });
            // console.log("phoneNo: ", phoneNo)
            const phone_number = '+62' + phoneNo;
            // console.log("custName: ",  custName);

            // console.log(interesting_unit, new_imei, old_brand, is_backup, is_working)
            let formData = new FormData();
            formData.append('qr_value', data);
            formData.append('customer_name', custName);
            formData.append('customer_phone', phone_number);
            formData.append('customer_email', email);
            formData.append('gender', gender);
            formData.append('customer_type', customerType.toString());
            formData.append('store_service_value', storeService.toString());
            formData.append('is_new_unit', newUnit.toString());
            formData.append('old_phone_brand', old_brand);
            formData.append('old_imei', oldIMEI);
            formData.append('new_imei', new_imei);
            formData.append('reasons', reason_not_buying);
            formData.append('interesting_unit', interesting_unit);
            formData.append('is_working', is_working);
            formData.append('is_vgc', isVGC.toString());
            formData.append('is_user_agreement_backup', is_backup.toString());
            formData.append('is_user_agreement_privacy', isPrivacy.toString());
            formData.append(
              'is_user_agreement_promotion',
              isPromotion.toString(),
            );
            formData.append('filename', file);
            // console.log("Submitting... ", isLoadingSubmit);
            // formData.forEach((val, i) => {
            //   console.log(i, ": ", val)
            // })
            try {
              await sbaas
                .script('post_data_form')
                .post({
                  headers: token,
                  body: formData,
                })
                .then(res => {
                  window.location.reload();
                  console.log('[post_data_form] res: ', res);
                });
            } catch (error) {
              console.log('Error: ', error);
              history.replace('/error');
            }
          }
        });
    } catch (error) {
      fetchPage();
      setIsLoadingKirim(false);
      return;
    }
  };

  const [lines, setLines] = React.useState<any>([]);
  const isDrawing = React.useRef(false);

  const handleMouseDown = (e: { target: { getStage: () => any } }) => {
    // e.target.getStage().preventDefault();

    isDrawing.current = true;
    const pos = e.target.getStage().getPointerPosition();
    setLines([...lines, { points: [pos.x, pos.y] }]);
  };

  const handleMouseMove = (e: {
    target: { getStage: () => any };
    evt?: any;
  }) => {
    // no drawing - skipping
    if (!isDrawing.current) {
      return;
    }
    e.evt.preventDefault();

    const stage = e.target.getStage();
    const point = stage.getPointerPosition();
    let lastLine = lines[lines.length - 1];
    // add point
    lastLine.points = lastLine.points.concat([point.x, point.y]);

    // replace last
    lines.splice(lines.length - 1, 1, lastLine);
    setLines(lines.concat());
  };

  const handleMouseUp = () => {
    isDrawing.current = false;
  };

  //functions --------------------------------

  function onChangeCB(checkedValues: any) {
    console.log('checkedCB = ', checkedValues);
    // console.log(checkedValues.includes('8'));

    const dataBackup = storeServices.find(
      (element: any) => element.service_name === 'Data Backup/ Smart Switch',
    );

    const demo = storeServices.find(
      (element: any) => element.service_name === 'Demo/ Settings/ Explanations',
    );

    setcbVal(checkedValues);
    setIsDataBackup(checkedValues.includes(dataBackup.service_bit_value));
    setIsDemo(checkedValues.includes(demo.service_bit_value));
  }

  function onChangeR(e: any) {
    setNewUnit(e.target.value);
    setStrOldPhone(e.target.value ? 'Lama' : 'Saat Ini');
  }

  function onChangeBackup(checkedValues: any) {
    setIsBackup(true);
    if (checkedValues.length === 0) {
      setIsBackup(false);
    }
  }

  function onChangePrivacy(checkedValues: any) {
    setIsPrivacy(true);
    if (checkedValues.length === 0) {
      setIsPrivacy(false);
    }
  }

  function onChangePromotion(checkedValues: any) {
    setIsPromotion(true);
    if (checkedValues.length === 0) {
      setIsPromotion(false);
    }
  }

  function handleChange(value: any) {
    console.log(`selected ${value}`);
    setOldBrand(value);
    // console.log(oldBrand)
  }

  function dataURItoBlob(dataURI: string) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    var ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], { type: mimeString });
    return blob;
  }

  const stageRef = React.useRef<any>(null);

  const hapus = () => {
    // stageRef.current.clear();
    setLines([]);
  };

  const checkAllMandatoryFields = () => {
    if (
      custName === null ||
      email === null ||
      phoneNo === null ||
      gender === '' ||
      newUnit === '' ||
      customerType === '' ||
      checkboxVal[0] === '0' ||
      checkboxVal.length == 0 ||
      lines.length === 0 ||
      (custName && custName.length > 50) ||
      !validateCustName(custName) ||
      !validateEmail(email) ||
      !validateIMEI(newIMEI) ||
      !validateIMEI(oldIMEI) ||
      !validatePhoneNumber(phoneNo) ||
      email.length > 50 ||
      (newUnit && (oldBrand === 'No Model' || newIMEI === '')) ||
      (!newUnit &&
        (reasonsNotBuying === null ||
          oldIMEI === '' ||
          ((reasonsNotBuying === 2 || reasonsNotBuying === 3) &&
            interestingUnit === null))) ||
      (isDemo && isWorking === null) ||
      (isDataBackup && !isBackup) ||
      !isPrivacy ||
      isVGC === ''
    ) {
      setDisablingSubmit(true);
      return;
    } else {
      setIsLoadingKirim(true);
      setLoadingSubmit(false);
      storeServicesToString();
    }
  };

  const getData = () => {
    const tokens: Headers = new Headers();
    let key: string | any = localStorage.getItem('token');
    tokens.append('x-sb-token', key);

    sbaas
      .dbGen('dbGeneric', 'cs_transaction_phone_brand')
      .get({
        headers: tokens,
      })
      .then(response => {
        // console.log('response_phone: ', response.data.data);
        setPhoneBrand(response.data.data);
      });

    sbaas
      .db('get_product_unit')
      .get({
        headers: tokens,
      })
      .then(response => {
        // console.log('Products: ', response.data.data);
        setUnit(response.data.data);
      });

    sbaas
      .dbGen('dbGeneric', 'cs_transaction_customer_reasons_not_to_buy')
      .get({
        headers: tokens,
        query: {
          'x-fields': 'id, reasons',
        },
      })
      .then(response => {
        // console.log(response.data.data);
        setReasons(response.data.data);
      });

    sbaas
      .dbGen('dbGeneric', 'cs_transaction_store_services')
      .get({
        headers: tokens,
        query: {
          'x-fields': 'service_name, service_bit_value',
        },
      })
      .then(response => {
        // console.log(response.data.data);
        setStoreServices(response.data.data);
      });
  };

  const onCancel = () => {
    setVisible(false);
    setIsLoadingKirim(false);
    setStrStoreServices('');
  };

  //hooks (useEffect) --------------------------------

  useEffect(() => {
    setIsLoading(true);
    getData();
  }, []);

  useEffect(() => {
    // console.log("checkin this...")
    if (
      custName === null ||
      email === null ||
      phoneNo === null ||
      gender === '' ||
      newUnit === '' ||
      customerType === '' ||
      checkboxVal[0] === '0' ||
      checkboxVal.length == 0 ||
      lines.length === 0 ||
      (custName && custName.length > 50) ||
      !validateCustName(custName) ||
      !validateEmail(email) ||
      !validateIMEI(newIMEI) ||
      !validateIMEI(oldIMEI) ||
      !validatePhoneNumber(phoneNo) ||
      email.length > 50 ||
      (newUnit && (oldBrand === 'No Model' || newIMEI === '')) ||
      (!newUnit &&
        (reasonsNotBuying === null ||
          oldIMEI === '' ||
          ((reasonsNotBuying === 2 || reasonsNotBuying === 3) &&
            interestingUnit === null))) ||
      (isDemo && isWorking === null) ||
      (isDataBackup && !isBackup) ||
      !isPrivacy ||
      isVGC === ''
    ) {
      setDisablingSubmit(true);
    } else {
      setDisablingSubmit(false);
    }
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      if (
        phoneBrand.length === 0 &&
        unit.length === 0 &&
        reasons.length === 0 &&
        storeServices.length === 0
      ) {
        console.log('Empty.');
        window.location.reload();
      } else {
        console.log('Fetching success.');
        setIsLoading(false);
      }
    }, 2500);
    return () => clearTimeout(timer);
  });

  useEffect(() => {
    if (strStoreServices !== '') {
      setVisible(true);
    }
  });

  const [finishStatus, setfinishStatus] = useState(false);

  const onBackButtonEvent = (e: any) => {
    e.preventDefault();
    if (!finishStatus) {
      if (window.confirm('Changes you made may not be saved.')) {
        setfinishStatus(true);
        // your logic
        history.push('/');
      } else {
        window.history.pushState(null, 'null', window.location.pathname);
        setfinishStatus(false);
      }
    }
  };

  useEffect(() => {
    window.history.pushState(null, 'null', window.location.pathname);
    window.addEventListener('popstate', onBackButtonEvent);
    return () => {
      window.removeEventListener('popstate', onBackButtonEvent);
    };
  }, []);

  useEffect(() => {
    window.onbeforeunload = () => {
      if (readyToSubmit) {
        return;
      } else {
        return true;
      }
    };
  });

  useEffect(() => {
    window.ononline = e => {
      console.log('Back Online ', e);
    };

    window.onoffline = e => {
      console.log('Connection Lost ', e);
    };
  });

  const onClickContactService = () => {
    history.replace('/contact-service');
  };

  return isLoading ? (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  ) : (
    <Fragment>
      <Header style={{ backgroundColor: 'white' }} className="header">
        <div className="logo" />
      </Header>

      <Row>
        <div className="header-banner"></div>
        <div className="submit-form-content">
          <span
            style={{
              fontFamily: 'Samsung Sharp Sans Bold',
              color: '#000000',
              margin: '15px 0 6px 0',
              display: 'block',
              fontSize: '14px',
            }}
          >
            Data Pelanggan
          </span>

          <Form
            layout={formLayout}
            form={form}
            initialValues={{ layout: formLayout }}
            onValuesChange={onFormLayoutChange}
          >
            <Form.Item
              label={
                <span style={{ fontWeight: 'bold' }}>
                  Nama Pelanggan<span style={{ color: '#FF2020' }}>*</span>
                  <Tooltip
                    title={nameTip}
                    color={'white'}
                    style={{ borderRadius: '10px' }}
                  >
                    {' '}
                    <InfoCircleOutlined />
                  </Tooltip>
                </span>
              }
              help={
                validateCustName(custName) ? (
                  ''
                ) : (
                  <span style={{ color: '#FF2020', fontSize: '10px' }}>
                    Nama tidak valid. Masukkan format nama yang benar tanpa
                    mengandung simbol, angka dan maksimal 50 karakter.
                  </span>
                )
              }
            >
              <Input
                placeholder=""
                onChange={e => setCustName(e.target.value.toUpperCase())}
                style={{ textTransform: 'uppercase' }}
              />
            </Form.Item>

            {/* --No HP */}
            <Form.Item
              label={
                <span style={{ fontWeight: 'bold' }}>
                  Nomor Handphone Pelanggan
                  <span style={{ color: '#FF2020' }}>*</span>
                </span>
              }
              help={
                validatePhoneNumber(phoneNo) ? (
                  ''
                ) : (
                  <span style={{ color: '#FF2020', fontSize: '10px' }}>
                    Nomor tidak valid, masukkan minimal 8 angka dan maksimal 12
                    angka.
                  </span>
                )
              }
            >
              <Input
                type="number"
                pattern="[0123456789]*"
                addonBefore="+62"
                placeholder=""
                onChange={e => {
                  setPhoneNo(e.target.value);
                }}
              />
            </Form.Item>

            {/* --Email */}
            <Form.Item
              label={
                <span>
                  Alamat E-mail Pelanggan
                  <span style={{ color: '#FF2020' }}>*</span>
                </span>
              }
              help={
                validateEmail(email) ? (
                  email && email.length > 50 ? (
                    <span style={{ color: '#FF2020', fontSize: '10px' }}>
                      Email tidak valid, masukkan maksimal 50 karakter.
                    </span>
                  ) : (
                    ''
                  )
                ) : (
                  <span style={{ color: '#FF2020', fontSize: '10px' }}>
                    Email tidak valid. Masukkan format email yang benar.
                  </span>
                )
              }
            >
              <Input onChange={e => setEmail(e.target.value)} max={10} />
            </Form.Item>

            {/* --Jenis Kelamin */}
            <Form.Item
              label={
                <span style={{ fontWeight: 'bold' }}>
                  Jenis Kelamin
                  <span style={{ color: '#FF2020' }}>*</span>
                </span>
              }
            >
              <Radio.Group
                onChange={e => setGender(e.target.value)}
                value={gender}
              >
                <Radio value={'L'}>Laki-laki</Radio> <br></br>
                <Radio value={'P'}>Perempuan</Radio> <br></br>
              </Radio.Group>
            </Form.Item>

            {/* --Tipe Pelanggan */}
            <Form.Item
              label={
                <span style={{ fontWeight: 'bold' }}>
                  Tipe Pelanggan
                  <span style={{ color: '#FF2020' }}>*</span>
                </span>
              }
            >
              <Radio.Group
                onChange={e => setCustomerType(e.target.value)}
                value={customerType}
              >
                <Radio value={1}>Walk In</Radio> <br></br>
                <Radio value={2}>Follow Up Database</Radio> <br></br>
              </Radio.Group>
            </Form.Item>

            {/* --Pembelian Unit Baru? */}
            <Form.Item
              label={
                <span style={{ fontWeight: 'bold' }}>
                  Pembelian Unit Baru?
                  <span style={{ color: '#FF2020' }}>*</span>
                </span>
              }
            >
              <Radio.Group onChange={onChangeR} value={newUnit}>
                <Radio value={true}>Ya</Radio> <br></br>
                <Radio value={false}>Tidak</Radio> <br></br>
              </Radio.Group>
            </Form.Item>

            {/* ---Alasan Tidak Melakukan Pembelian  */}
            <Form.Item
              label={
                <span style={{ fontWeight: 'bold' }}>
                  Alasan Tidak Melakukan Pembelian
                  <span style={{ color: '#FF2020' }}>*</span>
                </span>
              }
              hidden={newUnit ? true : false}
            >
              <Radio.Group
                onChange={e => setReasonsNotBuying(e.target.value)}
                value={reasonsNotBuying}
              >
                {reasons &&
                  reasons.map((element: any) => (
                    <>
                      <Radio value={element.id}>{element.reasons}</Radio>
                      <br />
                      <br />
                    </>
                  ))}
              </Radio.Group>
            </Form.Item>

            {/* --Tipe Unit yang Tertarik untuk Dibeli */}
            <Form.Item
              label={
                <span style={{ fontWeight: 'bold' }}>
                  Tipe Unit yang Tertarik untuk Dibeli
                  <span style={{ color: '#FF2020' }}>*</span>
                </span>
              }
              hidden={
                (reasonsNotBuying === 2 || reasonsNotBuying === 3) && !newUnit
                  ? false
                  : true
              }
            >
              <Select
                onChange={key => {
                  setInterestingUnit(key);
                }}
                showSearch
                onSearch={onSearch}
                filterOption={(input, option) =>
                  ((option!.children as unknown) as string)
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {unit &&
                  unit.map((element: any) => (
                    <Option label={element.name} key={element.id}>
                      {element.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            {/* --Merk Handphone Lama */}
            <Form.Item
              label={
                <span style={{ fontWeight: 'bold' }}>
                  Pilih Merk Handphone Lama yang Digunakan
                  <span style={{ color: '#FF2020' }}>*</span>
                </span>
              }
              hidden={newUnit ? false : true}
            >
              <Select onChange={handleChange}>
                {phoneBrand &&
                  phoneBrand.map((element: any, i: any) => (
                    <Option value={element.phone_brand} key={i}>
                      {element.phone_brand}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            {/* --Masukkan Nomor IMEI Handphone {strOldPhone} */}
            <Form.Item
              label={
                <span style={{ fontWeight: 'bold' }}>
                  Masukkan Nomor IMEI Handphone {strOldPhone}
                  {strOldPhone === 'Lama' ? null : (
                    <span style={{ color: '#FF2020' }}>*</span>
                  )}
                </span>
              }
              help={
                validateIMEI(oldIMEI) ? (
                  ''
                ) : (
                  <span style={{ color: '#FF2020', fontSize: '10px' }}>
                    IMEI tidak valid.
                  </span>
                )
              }
            >
              <Input
                onChange={e => setOldIMEI(e.target.value)}
                placeholder=""
              />
            </Form.Item>

            {/* --Masukkan Nomor IMEI Handphone Baru */}
            <Form.Item
              label={
                <span style={{ fontWeight: 'bold' }}>
                  Masukkan Nomor IMEI Handphone Baru
                  <span style={{ color: '#FF2020' }}>*</span>
                </span>
              }
              hidden={newUnit ? false : true}
              help={
                validateIMEI(newIMEI) ? (
                  ''
                ) : (
                  <span style={{ color: '#FF2020', fontSize: '10px' }}>
                    IMEI tidak valid.
                  </span>
                )
              }
            >
              <Input
                onChange={e => setNewIMEI(e.target.value)}
                placeholder=""
              />
            </Form.Item>

            {/* --Jenis Layanan Store */}
            <Form.Item
              label={
                <span>
                  Jenis Layanan Store<span style={{ color: '#FF2020' }}>*</span>
                </span>
              }
            >
              <Checkbox.Group style={{ width: '100%' }} onChange={onChangeCB}>
                {storeServices &&
                  storeServices
                    .filter(
                      (service_name: any) =>
                        service_name.service_name !==
                        'Empty Stock Notification',
                    )
                    .map((element: any) => (
                      <>
                        <Checkbox value={element.service_bit_value}>
                          <span style={{ fontSize: '12px' }}>
                            {element.service_name}
                          </span>
                        </Checkbox>{' '}
                        <br></br>
                      </>
                    ))}
              </Checkbox.Group>
            </Form.Item>

            {/* --Apakah Unit Berfungsi? */}
            <Form.Item
              label={
                <span style={{ fontWeight: 'bold' }}>
                  Apakah Unit Berfungsi?
                  <span style={{ color: '#FF2020' }}>*</span>
                </span>
              }
              hidden={isDemo ? false : true}
            >
              <Radio.Group
                onChange={e => setIsWorking(e.target.value)}
                value={isWorking}
              >
                <Radio value={true}>Ya</Radio> <br></br>
                <Radio value={false}>Tidak</Radio> <br></br>
              </Radio.Group>
            </Form.Item>

            {/* --VGC? */}
            <Form.Item
              label={
                <span style={{ fontWeight: 'bold' }}>
                  Apabila proses perbaikan/service di toko belum selesai, apakah
                  Anda bersedia dihubungkan dengan VGC (Virtual Galaxy
                  Consultant)? <span style={{ color: '#FF2020' }}>*</span>
                </span>
              }
            >
              <Radio.Group
                onChange={e => setIsVGC(e.target.value)}
                value={isVGC}
              >
                <Radio value={true}>Ya</Radio> <br></br>
                <Radio value={false}>Tidak</Radio> <br></br>
              </Radio.Group>
            </Form.Item>

            {/* --isDataBackup */}
            <div hidden={isDataBackup ? false : true}>
              <Checkbox.Group
                style={{ width: '100%' }}
                onChange={onChangeBackup}
              >
                <Checkbox value="A">
                  Dengan ini saya telah menyetujui untuk proses pemindahan data
                  melalui Smart Switch. Samsung tidak bertanggung jawab dan
                  tidak berkewajiban atas hal hal terkait keamanan, kehilangan,
                  perlindungan, kerahasiaan atau penggunaan dari data di dalam
                  perangkat lama dan perpindahan data ke Perangkat baru. Adalah
                  tanggung jawab Konsumen untuk Memastikan semua data tersebut
                  dihapus / dipindahkan seluruhnya sebelum diserahkan kepada
                  Samsung.<span style={{ color: '#FF2020' }}>*</span>
                </Checkbox>{' '}
              </Checkbox.Group>
              <br />
              <br />
            </div>

            <Checkbox.Group
              style={{ width: '100%' }}
              onChange={onChangePrivacy}
            >
              <Checkbox value="B">
                Dengan ini saya telah membaca, memahami dan menyetujui{' '}
                <a
                  href="https://www.samsung.com/id/info/privacy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <u>Kebijakan Privasi</u>
                </a>{' '}
                yang berlaku.<span style={{ color: '#FF2020' }}>*</span>{' '}
              </Checkbox>{' '}
            </Checkbox.Group>

            <br />
            <br />

            <Checkbox.Group
              style={{ width: '100%' }}
              onChange={onChangePromotion}
            >
              <Checkbox value="C">
                Dengan ini saya setuju untuk menerima promosi dan pemberitahuan
                oleh Samsung dan afiliasi di kemudian hari. (Opsional)
              </Checkbox>{' '}
            </Checkbox.Group>

            <br />
            <br />

            <Form.Item
              label={
                <span style={{ fontWeight: 'bold' }}>
                  Tanda Tangan Pelanggan
                  <span style={{ color: '#FF2020' }}>*</span>
                </span>
              }
              required
            >
              <div
                style={{
                  maxWidth: '350px',
                  border: '1px solid',
                  overflow: 'hidden',
                }}
              >
                <Stage
                  ref={stageRef}
                  style={{ maxWidth: '350px' }}
                  width={
                    window.innerWidth < 350 ? window.innerWidth - 46.43 : 350
                  }
                  height={240}
                  onMouseDown={handleMouseDown}
                  onMousemove={handleMouseMove}
                  onMouseup={handleMouseUp}
                  onTouchMove={handleMouseMove}
                  onTouchStart={handleMouseDown}
                  onTouchEnd={handleMouseUp}
                >
                  <Layer>
                    {lines.map((line: any, i: React.Key | null | undefined) => (
                      <Line
                        key={i}
                        points={line.points}
                        stroke="#000"
                        strokeWidth={4}
                        tension={0.5}
                        lineCap="round"
                        preventDefault={true}
                      />
                    ))}
                  </Layer>
                </Stage>
                <Button
                  style={{
                    position: 'absolute',
                    top: '200px',
                    left: '0',
                    border: 'none',
                    marginBottom: '8px',
                    background: 'none',
                  }}
                  onClick={hapus}
                >
                  <RedoOutlined rotate={200} style={{ fontSize: '24px' }} />
                </Button>
              </div>
            </Form.Item>

            <Form.Item style={{ textAlign: 'center' }}>
              <Button
                className="submit-form-button"
                type="primary"
                onClick={checkAllMandatoryFields}
                disabled={disablingSubmit}
                loading={isLoadingKirim}
              >
                Kirim
              </Button>
            </Form.Item>
            <br />
          </Form>
        </div>
      </Row>

      <Modal
        // overlayClassName="sw-table-search-overlay"
        className="searchModal"
        title={'Konfirmasi Data'}
        visible={visible}
        footer={
          <>
            <Row>
              <Button
                className="submit-form-button"
                type="primary"
                onClick={() => {
                  setreadyToSubmit(true);
                  setLoadingSubmit(true);
                  submitData();
                }}
                style={{
                  marginTop: '10px',
                }}
                loading={isLoadingSubmit}
              >
                Ya, Data Sudah Benar
              </Button>
            </Row>

            <Row>
              <Button
                className="submit-form-button"
                onClick={onCancel}
                style={{
                  backgroundColor: 'white',
                  color: '#04BBDB',
                  border: 'solid 2px #04BBDB',
                  verticalAlign: 'top',
                  marginTop: '10px',
                }}
              >
                Belum, Perbarui Data
              </Button>
            </Row>
          </>
        }
        closable={false}
        onCancel={onCancel}
      >
        <b>Nama Lengkap:</b> <br />
        <span style={{ color: '#0984CD' }}>{custName}</span>
        <br />
        <br />
        <b>Nomor Handphone Aktif:</b> <br />
        <span style={{ color: '#0984CD' }}>+62{phoneNo}</span>
        <br />
        <br />
        <b>Alamat Email Aktif:</b> <br />
        <span style={{ color: '#0984CD' }}>{email}</span>
        <br />
        <br />
        <b>Jenis Kelamin:</b> <br />
        <span style={{ color: '#0984CD' }}>
          {gender === 'L' ? 'Laki-laki' : 'Perempuan'}
        </span>
        <br />
        <br />
        <b>Tipe Pelanggan:</b> <br />
        <span style={{ color: '#0984CD' }}>
          {customerType === 1 ? 'Walk In' : 'Follow Up Database'}
        </span>
        <br />
        <br />
        {newUnit ? (
          <>
            <b>Merk Handphone Lama:</b> <br />
            <span style={{ color: '#0984CD' }}>{oldBrand}</span>
            <br />
            <br />
          </>
        ) : null}
        <b>Nomor IMEI Handphone {strOldPhone}:</b> <br />
        <span style={{ color: '#0984CD' }}>{oldIMEI ? oldIMEI : '-'}</span>
        <br />
        <br />
        {newUnit ? (
          <>
            <b>Nomor IMEI Handphone Baru:</b> <br />
            <span style={{ color: '#0984CD' }}>{newIMEI}</span>
            <br />
            <br />
          </>
        ) : null}
        <b>Jenis Layanan Store:</b> <br />
        <span style={{ color: '#0984CD' }}>{strStoreServices}</span>
        <br />
        <br />
        <br />
        Apakah data yang Anda masukkan sudah lengkap dan merupakan data yang
        benar?
      </Modal>

      <Modal
        className="searchModal"
        title={'Formulir yang Anda gunakan kadaluwarsa!'}
        visible={visibleRefresh}
        footer={
          <div>
            <Button
              className="submit-form-button"
              onClick={() => {
                window.location.reload();
              }}
              style={{
                backgroundColor: '#04BBDB',
                color: '#fff',
                border: 'solid 2px #04BBDB',
                verticalAlign: 'top',
              }}
            >
              Ok
            </Button>
            <br />
            <br />
          </div>
        }
        closable={false}
        onCancel={onCancel}
      >
        Silakan muat ulang halaman dengan memindai kembali kode QR atau masukkan
        url terbaru.
      </Modal>
      <Form.Item style={{ textAlign: 'center' }}>
        <Button
          onClick={onClickContactService}
          style={{ background: 'none', border: 'none' }}
        >
          <p style={{ color: 'grey', textDecoration: 'underline' }}>
            Contact Service
          </p>
        </Button>
      </Form.Item>
    </Fragment>
  );
};

export default DataForm;
